import accountFillSVG from '../../assets/icons/account-fill.svg';
import { CoreIcon } from '../core-icon';

import type { IconProps } from '../core-icon';

export const AccountFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={accountFillSVG} {...props} />;
};
